import { FC } from 'react';
import clsx from 'clsx';
import { Box } from '@wix/design-system';
import { FavoriteFilledSmall } from '@wix/wix-ui-icons-common';
import ReviewScore from '../ReviewScore';
import CompletedProjectCount from '../CompletedProjectCount';
import s from '../ProviderReviewSummary.module.scss';

interface NoReviewsDesktopProps {
  isMobileView: boolean;
  isStickyMobileView: boolean;
  completedProjects: number;
  containerClassName?: string;
}

const NoReviewsDesktop: FC<NoReviewsDesktopProps> = ({
  isMobileView,
  isStickyMobileView,
  completedProjects,
  containerClassName,
}) => {
  return (
    <Box
      direction="vertical"
      dataHook="provider-review-summary"
      className={clsx(s.noReviewsDesktop, containerClassName)}
    >
      <Box direction="horizontal" paddingLeft="2px" verticalAlign="middle">
        <CompletedProjectCount
          isMobileView={isMobileView}
          completedProjectsCount={completedProjects}
        />
      </Box>
      <Box direction="horizontal" verticalAlign="middle">
        <FavoriteFilledSmall
          className={s.ratingStarIcon}
          color="#CFD1DC"
          size="18px"
        />
        <ReviewScore
          isMobileView={isMobileView}
          isStickyMobileView={isStickyMobileView}
          averageReviewRating={0}
          reviewsCount={0}
        />
      </Box>
    </Box>
  );
};

export default NoReviewsDesktop;
